var common = require("../../../utiles/common.js")
var c = require("../../../utiles/entranceConfig");
var loginUtils = require("../LoginUtils");

require("./smallConcise.less")

module.exports = {
    register: function () {
        document.createElement('small-login-form')
        ko.components.register('small-login-form', {
            viewModel: function (params) {
                var $this = this;
                $this.entrance = c.entrance;
                $this.qrcode = ko.observable("");
                $this.tabActive = ko.observable("pwd");
                $this.ajaxUrl = ko.observable("");
                $this.loginActive = ko.observable("user");
                $this.enabled = ko.observable();
                $this.enabled = ko.observable();
                $this.loginEntrance = loginUtils.getLoginEntrance();
                $this.getQR = function(){
                    var QRS = [];
                    for(var key in $this.loginEntrance){
                        if(key.indexOf("QR")>-1){
                            QRS.push(key);
                        }
                    }
                    return QRS;
                }
                $this.QRS = $this.getQR();
                $this.loginMethod = ko.observable(loginUtils.getPriorityMax($this.loginEntrance));
                console.log($this.loginEntrance)
                $this.isVerifyCodeVisible = ko.observable(common.fetch("/auth/verification/need",{type:"GET",query:{type:"LOGIN"}}).data)
                common.fetch("/auth/getLoginAction", {
                    type: "GET",
                    success:function(result){
                        console.log(result)
                        $this.loginAction = result.data;
                    }
                })
                //忘记密码判断
                // common.fetch("/auth/portal/config/getPortalConfig", {
                //     type: "GET",
                //     success:function(result){
                //         console.log(result)
                //     }
                // })
                $this.errorMessage = ko.observable("");
                $this.keypress = function (keyCode) {
                    if (keyCode == 13) {
                        $this.login();
                    }
                }
                $this.userKeypress = function (keyCode) {
                    if (keyCode == 13) {
                        $("input[type=password]").focus();
                    }
                }
                
                $this.getQrCode = function(){
                    return JSON.stringify(common.fetch("/auth/qr/login/generateQRCode", {
                        type: "GET"
                    }).data);
                }
                $this.loginBack = function (result,isAD){
                    if(result.data){
                        if(result.data.url){
                            common.redirectTo(result.data.url);
                        }else if(result.data.needVerifyCode){
                            $this.isVerifyCodeVisible(true);
                            $("img.verifyImg").attr("src", "/auth/verification/img?type=LOGIN&random=" + Math.random());
                        }
                        if(result.data.message&&result.data.message.replace(/^\s+|\s+$/g,"")){
                            if(isAD){
                                common.message("error",result.data.message);
                            }else{
                                common.errorAlert(result.data.message);
                            }
                        }
                    }else if(result.message){
                        common.errorAlert(result.message);
                    }else{
                        common.errorAlert(commonLocal.describe.AbnormalError);
                    }
                }
                
                $this.openCode = function(key){
                    $this.loginMethod(key);
                    var state = sessionStorage.getItem("state")?sessionStorage.getItem("state"):"";
                    var data = common.fetch($this.loginEntrance[key].baseUrl+$this.loginEntrance[key].url, {
                        type: "GET",query: {state:state}});
                    if (window.WwLogin) {
                        window.WwLogin({
                            id: 'qrcode-container-'+key,
                            href: '',
                            agentid: data.agentid,
                            state: data.state,
                            appid: data.appid,
                            redirect_uri: data.redirect_uri+"?"+encodeURIComponent(window.location.href.split("?")[1])
                        });
                    }
                }
                if($this.loginMethod().indexOf("QR")>-1){
                    setTimeout(function(){
                        $this.openCode($this.loginMethod());
                    },200)
                }
                $this.login = function () {
                    console.log($("body").data("service"))
                    var postD = $('.pwdLogin input').serializeObject();
                    if (postD.verifyCode == "") {
                        common.message("error", commonLocal.describe.VerificationCodeIsRequired);
                        return false;
                    }
                    var service = sessionStorage.getItem("service");
                    var callBack = sessionStorage.getItem("callBack") ? sessionStorage.getItem("callBack") : "";
                    if (service) {postD.service = service;}
                    if (callBack) {postD.callBack = callBack;}
                    if (postD.password) {
                        var pwdType = {decryptType: "SM2"};
                        try {
                            pwdType.cryptKey = "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
                        } catch (error) {
                        }
                        console.info("postD.password", pwdType)
                        postD.password = common.sm2.doCrypt(pwdType.cryptKey, postD.password);
                    }
                    var searchUrl = sessionStorage.getItem("searchUrl")?sessionStorage.getItem("searchUrl"):""
                    console.log(postD)
                    var ajaxUrl = $this.loginEntrance[$this.loginMethod()].baseUrl+$this.loginEntrance[$this.loginMethod()].url+"?"+searchUrl;
                    common.fetch(ajaxUrl, {
                        type: "POST",
                        data: JSON.stringify(postD),
                        handleError: function (data) {
                            $("img.verifyImg").attr("src", "/auth/verification/img?type=LOGIN&random=" + Math.random());
                        },
                        success: function (result) {
                            console.log(result)
                            $this.loginBack(result);
                        }
                    })
                }

                //window c端登录
                if($this.loginEntrance.AD){
                    var anonymous = $this.loginEntrance.AD.autoLogin;
                    var spnego = sessionStorage.getItem("spnego");
                    $this.enabled(anonymous);
                    $this.spnegoLogin = function () {
                        $.ajax({
                            url: $this.loginEntrance.AD.baseUrl+$this.loginEntrance.AD.url,
                            success: function (data) {
                                console.log(data);
                                common.redirectTo("/#/");
                            },
                            error: function (result) {
                                console.log(result);
                                sessionStorage.setItem("spnego", true);
                                $this.loginBack(JSON.parse(result.responseText),true);
                            }
                        });
                    }
                    if (!spnego && $this.enabled()) {
                        $this.spnegoLogin();
                    }
                }

                //Windows CP自动登录
                var intervalObj = null;//计时器
                var i = 0;
                //启动计时器函数
                function startCheck(){
                    if(intervalObj != null){
                        clearInterval(intervalObj);
                        intervalObj = null;
                    }
                    intervalObj = setInterval(loginCheck, 1000);//启动计时器，调用overs函数，
                }
                function loginCheck(){
                    i++;
                    common.fetch("/auth/isLogin", {
                        success: function (data) {
                            if(data.data){
                                // 结束检查
                                stopCheck();
                                // 如果用户已经登录则直接跳转
                                common.redirectTo("/#/appList")
                            }else{
                                // 如果无用户会话，则循环探测6次后结束检查
                                if(i > 5){
                                    // 结束检查
                                    stopCheck();
                                }
                            }
                        }
                    });
                }
                function stopCheck(){
                    clearInterval(intervalObj);
                    intervalObj = null;
                }
                //域登录
                // var isWinLogout = sessionStorage.getItem("isWinLogout");
                // if(!isWinLogout){
                //     $("#winLoginContent").html('<iframe id="jsWinLogin" name="jsWinLogin" src="http://127.0.0.1:26262/pam/agent/getToken" style="display: none"></iframe><iframe id="jsWinLogin" name="jsWinLogin" src="http://127.0.0.1:26262/auth/sso/jsWinLogin" style="display: none"></iframe>');
                //     // 启动setInterval循环检查用户是否登录跳转
                //     startCheck();
                // }

            },
            template: require("./SmallConciseForm.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/login/smallConcise/SmallConcise.js
// module id = 104
// module chunks = 0